<template>
    <div>
        <div v-if="0 < loadingProcesses"
             class="lds-dual-ring"
        ></div>
        <div
            v-else
            class="box-offset">
            <div
                class="box-ttl-wrap"
                v-if="!showExistingEvent"
            >
                <div class="box-ttl ">
                    Select an appointment time
                </div>
            </div>
            <div
                class="appointment-calendar-wrap"
                v-if="!showExistingEvent"
            >
                <div class="calendar-wrap mt-2">

                    <VDatePicker
                        v-model="selectedDate"
                        :attributes="attrs"
                        :max-date="maxDay"
                        :min-date="new Date()"
                        @dayclick="getAppointmentAvailability"
                    />

                </div>
                <div class="appointments-days">

                    <DaySlots
                        v-for="day in slots.arrayOfDays"
                        :key="day.day"
                        :max-date="maxDay"
                        :selected-day="selectedDate"
                        :selected-slot="selectedSlot"
                        :dayInfo="day"
                        :workday-settings="appointmentSettings"
                        :events="getDayEvents(day.date)"
                        @update-slot=updateSelectedSlot
                    />

                </div>
            </div>

            <div class="selected-appointment">
                <div class="text-right">
                    <a href="/application/profile?tab=Status" class="btn btn--outline-primary">Back</a>
                    <button
                        v-show="showSaveButton"
                        class="btn btn--primary"
                        @click="showCustomModal('interview', userId)"
                    >Save
                    </button>
                    <ActionModal confirm-text="Yes" reject-text="No"
                                 :modalId="getCustomModalId('interview', userId)"
                                 @confirm="sendAppointmentEvent">
                        <template #body>
                            <div class="text-center mb-4">
                                <h4>
                                    Do you want <br> to book the appointment?
                                </h4>
                            </div>
                        </template>
                    </ActionModal>
                </div>

                <SelectedSlot
                    v-if="showExistingEvent"
                    :appointment-info="existingAppointment"
                    @update-interview="reloadSchedule"
                    :hide-deleting="timePassed"
                />

            </div>
        </div>
    </div>
</template>

<script>
import AppointmentService from "../../services/AppointmentService";
import moment from "moment/moment";
import DaySlots from "./DaySlots.vue";
import SelectedSlot from "./SelectedSlot.vue";
import ModalHandler from "../../../../../../../resources/js/mixins/ModalHandler";
import ActionModal from "../../../../../../../resources/js/components/ActionModal.vue";

export default {
    name: 'AppointmentBlock',
    components: {ActionModal, SelectedSlot, DaySlots,},
    props: {
        userId: Number,
    },
    mixins: [ModalHandler,],
    data() {
        return {
            timePassed: false,
            showSaveButton: false,
            existingAppointment: {},
            showExistingEvent: false,
            loadingProcesses: 0,
            selectedDate: new Date(),
            events: [],
            slots: {
                weekSchedule: [],
                arrayOfDays: [],
            },
            maxDay: null,
            selectedSlot: null,
            appointmentSettings: {},
            attrs: [{
                key: 'today',
                highlight: {
                    color: 'blue',
                    fillMode: 'light',
                    contentClass: 'italic',
                },
                dates: new Date(),
            },]
        }
    },

    methods: {
        reloadSchedule(){
            this.getExistingEvent()
            this.getWeeklyEvents()
        },
        meetingTimeIsUp() {
            if (this.showExistingEvent) {
                const startEvent = new Date(this.existingAppointment.start_date)
                const now = new Date().getTime()
                this.timePassed = startEvent < now
            }
        },
        async getExistingEvent() {
            try {
                const {data: response} = await AppointmentService.getAppointmentInfo(this.userId)
                this.existingAppointment = response
                this.showExistingEvent = Object.keys(this.existingAppointment).length !== 0
                this.meetingTimeIsUp()
            } catch {
            }
        },
        createWeek() {
            this.slots.arrayOfDays = []
            const endDate = moment(this.selectedDate).add(6, 'days');
            for (let start = moment(this.selectedDate); start.isSameOrBefore(endDate); start.add(1, 'days')) {
                const weekday = start.format('ddd');
                const day = start.format('D');
                const date = start.format('MM-DD-YYYY');
                const formattedDate = {
                    weekday: weekday,
                    day: day,
                    date: date,
                }
                this.slots.arrayOfDays.push(formattedDate);
            }
        },
        getMaxDate() {
            const date = moment().add(this.appointmentSettings.maximum_time, 'days')
            this.maxDay = date.format('YYYY-MM-DD');
        },
        generateSchedule() {
            this.slots.weekSchedule = [];
            this.arrayOfDays.forEach(day => {
                this.info.schedule.push({
                    index: day,
                    date: day,
                    location: null,
                    time_in: null,
                    time_out: null,
                    result: null,
                });
            });
        },
        async getWeeklyEvents() {
            this.loadingProcesses += 1;

            try {
                const {data: response} = await AppointmentService.getEventsForAWeek(this.selectedDate)
                this.events = response.reduce((acc, obj) => {
                    const key = this.getDayKey(obj.start_date);
                    if (!acc[key]) {
                        acc[key] = [];
                    }
                    acc[key].push(obj);
                    return acc;
                }, {});
            } catch (e) {
                this.$showErrorMessage('Cant upload event for 7 days')
            } finally {
                this.loadingProcesses -= 1;
            }
        },
        async getAppointmentSettings() {
            this.loadingProcesses += 1;

            try {
                const {data: response} = await AppointmentService.getWorkdaySettings()
                this.appointmentSettings = response
                this.getMaxDate()
            } catch (e) {
                this.$showErrorMessage('Cant get appointment settings')
            } finally {
                this.loadingProcesses -= 1;
            }
        },
        getAppointmentAvailability(date) {
            this.selectedDate = date.date
            this.getWeeklyEvents()
            this.createWeek()
        },
        getDayEvents(date) {
            return this.events[this.getDayKey(date)] ?? [];
        },
        async sendAppointmentEvent() {
            this.$showLoadingMessage()
            const payload = {
                start_date: this.selectedSlot,
                all_day: false,
            }
            try {
                await AppointmentService.sendAppointmentInfo(this.userId, payload)
                this.$showSuccessMessage('The appointment request was sent')
                this.selectedSlot = null
                await this.getExistingEvent()
            } catch {
                this.$showErrorMessage('The appointment request was not sent. Please try again',)
            }
        },
        updateSelectedSlot(slot) {
            this.selectedSlot = this.getTimeForBooking(slot)
            this.showSaveButton = !this.showExistingEvent && this.selectedSlot !== null

        }
    },
    watch: {
        selectedSlot(newVal, oldVal) {
            this.showSaveButton = !this.showExistingEvent && newVal !== null;
        }
    },
    mounted() {
        this.getAppointmentSettings()
        this.getWeeklyEvents()
        this.createWeek();
        this.getExistingEvent()

    }

}

</script>


<style scoped>

</style>
